import lyubenImage from '../assets/img/lyuben.jpg';
import daliyaImage from '../assets/img/daliya.jpg';

export const lyuben = {
    doctorName: 'Д-р Любен Томов',
    doctorImage: lyubenImage,
    doctorDescription: `Д-р Любен Томов е дипломиран магистър по дентална медицина
    към Факултет по дентална медицина на Медицински Университет – гр.София.
    Член на Български зъболекарски съюз /БЗС/ от 2011г. Посвещава следдипломното си
    обучение на естетичната възстановителна дентална медицина и денталната
    имплантология, дигиталното планиране на усмивката с керамични фасети, циркониеви
    и керамични конструкции.`,
    timelineEvents: [
        {
            year: '2012',
            description:
                'Преминава курс за машинно инструментиране на кореновите канали и поставяне на кофердам - лектор д-р Гари Гласман.',
        },
        {
            year: '2014',
            description:
                'Завършва обучение по клинична пародонтология с лектори Panagiotis Dagalis и Ioannis Vouros.',
        },
        {
            year: '2015',
            description:
                'Завършва обучение в областта на директни адхезивни възстановявания във фронталната и дисталната област - бондинг на предни и задни зъби по методиката на проф. Ванини – Швейцария.',
        },
        {
            year: '2016',
            description:
                'Завършва специализиран курс за диагностика, планиране, изработка и поставяне на керамични фасети - Винченцо Муцела, Италия.',
        },
        {
            year: '2018',
            description:
                'Преминава следдипломна специализация по дентална имплантология към факултета по дентална медицина гр София.',
        },
        {
            year: '2022',
            description:
                'Преминава обучение по оклузия, функция и естетика, д-р Кирил Динов.',
        },
        {
            year: '2023',
            description:
                'Prof. Paul Swanson – All on four – имплантология и протезиране. Неколкократно участие на Sofia Dental Meeting.',
        },
    ],
};

export const daliya = {
    doctorName: 'Д-р Далия Томова',
    doctorImage: daliyaImage,
    doctorDescription: `Д-р Далия Томова е дипломиран магистър по дентална медицина
    към Факултет по дентална медицина на Медицински Университет – гр.София.
    Член на Български зъболекарски съюз /БЗС/ от 2013г. Работи изключително в областта на
    ортодонтията за деца и възрастни. През годините на професионалия й път преминава
    специализирано обучение по ортодонтия по американската ортодонтска система Алекзандър,
    създадена от Проф. Уик Алекзандър. Сертифицирана е за работа с алайнери Invisalign. През
    2017 г. завършва специализиран курс по естетична дерматология - работа с ботулинов токсин
    и дермални филъри в лицевата област. Като използва качествата на филърите и ботокса, д-р Томова
    изцяло завършва лицевата естетика на пациентите си.`,
    timelineEvents: [
      {
        year: '2017',
        description:
          'Завършва специализиран курс по естетична дерматология - работа с ботулинов токсин и дермални филъри в лицевата област.',
      },
      {
        year: '2017',
        description:
          'Проф. Димитър Филчев - Ранно ортодонтско лечение.',
      },
      {
        year: '2023',
        description:
          'Dr. Ali Ouazzani – Лечение на сложни ортодонтски случаи.',
      },
      {
        year: '2023',
        description:
          'Prof. Mara Manente, prof. Azzurra Di Ventura - Ранно ортодонтско лечение и детска дентална медицина.',
      },
      {
        year: '2024',
        description:
          'Smile Galaxy Conference – д-р Граса Гимарейс, д-Иван Горялов, д-р Деница Димитрова, д-р Калин Маринов - Лечение на сложни ортодонтски случаи.',
      },
      {
        year: '2024',
        description:
          'Dr. Nikola Derton, президент на италианския борд на ортодонтите - Иновативни интра- и екстраалвеоларни мини импланти при лечения с брекети и алайнери.',
      },
    ],

  };

  const doctorInfo = {
    lyuben, daliya
  }
export default doctorInfo